<template>
  <div style="margin-top: 25px">
    <div style="margin: 10px;display: flex;flex-direction: row;align-items: center">
      <div style="width: 5px;height: 18px;background-color: #ffbc42;border-radius: 8px"/>
      <a style="font-size: 18px;color: #333333;margin-left: 10px">主讲教师</a>
    </div>
    <div style="margin-left: -40px">
      <div style="height: 1px;width: 100%;background-color: #f2f2f2"/>
      <ul class="teachers">
        <li v-for="teacher in teachers" :data-teacher_id="teacher.teacher_id">
          <el-card :body-style="{ padding: '0'}" style="border-radius: 8px;">
            <div style="display: flex;flex-direction: column;height: 470px">
              <img style="width: 100%;height: 250px;background-image:url(http://image.app.winlesson.com/subjejctInfoFolder/root/wl_69237_36142_8547.png) ;object-fit: contain;padding-top: 10px" :src="teacher.teacher_head">
              <a style="margin-top: 10px;text-align: center;font-size: 18px">{{ teacher.teacher_name }}</a>
              <a style="margin-top: 10px;text-align: center;font-size: 14px;color: #999999; white-space: pre-line;">{{
                  teacher.teacher_title
                }}</a>
              <a class="teacher_decs">{{teacher.teacher_desc }}</a>
            </div>
          </el-card>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {api_info_article, info_main, upload_read_num} from "../../networks/InfoArticleHandler";

export default {
  data() {
    return {
      teachers: [
        {
          teacher_id: 0,
          teacher_name: '石静',
          teacher_desc: '负责数量关系和资料分析的题库研发\n累计教学人次30000+\n熟悉国省考考情和命题趋势\n多年公职考试教学，研发，项目管理经验',
          teacher_head: 'http://image.app.winlesson.com/subjejctInfoFolder/root/wl_50077_18504_57736.png',
          teacher_title: '必胜公考教研院院长\n资深行测理讲师'
        },
        {
          teacher_id: 0,
          teacher_name: '解艺鸿',
          teacher_desc: '历任某大型公考集团教研室主任，主讲申论，结构化，半结构化，无领导小组面试\n累计授课10000+课时\n授课思路清晰严谨，经验丰富，幽默风趣，富有亲和力和感染力，让学员在轻松的氛围中，高效率地学到知识、技巧及思维方式',
          teacher_head: ' http://image.app.winlesson.com/subjejctInfoFolder/root/wl_16396_4855_75471.png',
          teacher_title: '必胜公考申论组负责人\n申论讲师，面试讲师'
        },
        {
          teacher_id: 0,
          teacher_name: '于小雨',
          teacher_desc: '日本法政大学交流学者，主讲中央国家机关及地方省市公务员面试，申论课程\n授课风格风趣幽默，善于调动课堂气氛，注重讲练结合以及个性化教学\n做练结合以及个性化教学，独创三步文章写作法\n结合历年真题列举实例，帮助学生理解，使学员在轻松氛围中提升能力。',
          teacher_head: 'http://image.app.winlesson.com/subjejctInfoFolder/root/wl_10308_8462_62594.png',
          teacher_title: '必胜公考面试组负责人\n面试讲师，申论讲师'
        },
        {
          teacher_id: 0,
          teacher_name: '张晓英',
          teacher_desc: '从事由论教学多年，授课风格简洁利落\n多次担任过过大课、考前冲刺封闭班次课程主讲，军转干、遗选等难度较大的课程也均有经验。\n授课类型包括础课，题海，封闭，网课，录课等:千练的授课风格颇受学生喜欢，强调申论的学习要专项和针对对于申论命题方向洞察敏锐。',
          teacher_head: 'http://image.app.winlesson.com/subjejctInfoFolder/root/wl_11390_3127_2257.png',
          teacher_title: '教学总监\n申论讲师，培训师'
        },
        {
          teacher_id: 0,
          teacher_name: '范渊清',
          teacher_desc: '原某机构行测教研室主任，培训训师。\n累计授课5000+小时，培训学员30000+余人。 授课风格：逻辑清晰，方法实用，语言幽默生动，课程讲解细致，能够用简洁直白的语言帮助学员掌握晦涩的内容，深受全国各地学员的喜欢',
          teacher_head: 'http://image.app.winlesson.com/subjejctInfoFolder/root/wl_3632_64979_31764.png',
          teacher_title: '行测组负责人\n专注于言语理解与表达，判断推理'
        },
      ],
    }
  },
  created: function () {

  },
  methods: {}
};
</script>

<style>

.el-aside {
  color: #333;
  text-align: center;
}

.title {
  font-weight: normal;
  border-bottom: 1px #f2f2f2 solid;
}

.info_title {
  background-color: #ffffff;
  color: #555555;
  font-size: 14px;
  display: flex;
  padding-left: 20px;
  padding-right: 20px;
  flex-direction: row;
  align-items: center;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.info_title2 {
  background-color: #f8f8f8;
  color: #555555;
  font-size: 14px;
  display: flex;
  padding-left: 20px;
  padding-right: 20px;
  flex-direction: row;
  align-items: center;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.area-list {
  float: left;
  padding: 0;
  padding-right: 10px;
  list-style: none;
}

.area_text_non {
  width: 50px;
  text-align: center;
}

.area_text {
  font-weight: bold;
  width: 50px;
  text-align: center;
  color: #ffbc42;
}


.teachers {
  list-style: none;
}

.teachers li {
  width: calc((100% / 4) - 15px);
  float: left;
  margin-left: 10px;
  margin-right: 10px;
}

.frame img:not(.icon) {
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.teachers li h5 {
  margin: 3px;
  font-size: 16px;
}

.teachers li p {
  margin: 3px;
  font-size: 12px;
  color: #999;
}

.teachers li:nth-of-type(3n) {
  margin-right: 0;
}

.teachers li:nth-of-type(n+4) {
  margin-top: 20px;
}

.teacher_decs{
  font-size: 12px;
  padding: 10px;
  min-height: 90px;
  white-space: pre-line;
}


</style>



// WEBPACK FOOTER //
// src/components/Layout/teachersInfo.vue